<template>
  <div class="file-head-content">
    <div class="file-header">
      <div class="file-header-title">Dossier de candidature</div>
      <div class="file-header-logo"><img src="@/assets/img/logo.png"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CandidatureHeader",
};
</script>